import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// bootstrap-slider
import bFormSlider from 'vue-bootstrap-slider';
// import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import 'bootstrap-slider/dist/css/bootstrap-slider.css'
// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExternalLinkAlt, faEnvelope, faMapMarkerAlt, faPaperPlane} from '@fortawesome/free-solid-svg-icons'
// Vue slider
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.config.productionTip = false

// bootstrap
Vue.use(BootstrapVue)
Vue.use(bFormSlider)
Vue.config.productionTip = false

// fontawesome
library.add(faPlus)
library.add(faEye)
library.add(faChevronLeft)
library.add(faExternalLinkAlt, faEnvelope, faMapMarkerAlt, faPaperPlane)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue slider
Vue.component('VueSlider', VueSlider)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
